function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function AdviceIcon(props) {
  return ___EmotionJSX(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props), ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M12.5 10.5v3"
  }), ___EmotionJSX("circle", {
    fill: "currentColor",
    cx: "12.5",
    cy: "8.5",
    r: ".5"
  }), ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M14.5 23.5h-4M15.5 21.5h-6M12.5.5v1M22.5 10.5h-1M2.5 10.5h1M3.5 3.5l1 1M20.5 3.5l-1 1"
  }), ___EmotionJSX("path", {
    d: "M19 10.5A6.5 6.5 0 0 0 12.4 4 6.6 6.6 0 0 0 6 10.4a6.5 6.5 0 0 0 4 6.1V18a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.5a6.5 6.5 0 0 0 4-6z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
}